import { Grid, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React from "react";
import UniqueVsDuplicateComparison from "./UniqueVsDuplicateComparison";
import PercentIcon from '@mui/icons-material/Percent';
import EnvironmentalImpact from "./EnvironmentalImpact";

export default class Impact extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            by: 'size',
            is_percentage: false,
            environmental_impact_by: 'energy'
        }

    }

    render() {
        return (
            <>
                <UniqueVsDuplicateComparison
                    by={this.state.by}
                    is_percentage={this.state.is_percentage}
                />
                
                <Grid item xs={12} style={{ paddingTop: 16 }}>
                    <ToggleButton
                        value="percentage"
                        selected={this.state.is_percentage}
                        onChange={() => this.setState((prevState) => ({ is_percentage: !prevState.is_percentage }))}
                        sx={{ mr: 2 }}
                        size='small'
                        color='primary'
                    >
                        <PercentIcon fontSize="small" />
                    </ToggleButton>

                    <ToggleButtonGroup
                        value={this.state.by}
                        exclusive
                        onChange={(e, value) => {
                            if (value !== null) {
                                this.setState({ by: value });
                            }
                        }}
                        aria-label="file sub category analytics group"
                        color='primary'
                    >
                        <ToggleButton value="count" aria-label="left aligned" size="small">
                            <Typography variant="body2" fontSize="small">Count</Typography>
                        </ToggleButton>
                        <ToggleButton value="size" aria-label="centered" size="small">
                            <Typography variant="body2" fontSize="small">Size</Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>

                <br /><br />

                <EnvironmentalImpact
                    by={this.state.environmental_impact_by}
                />

                <Grid item xs={12} style={{ paddingTop: 16 }}>
                    <ToggleButtonGroup
                        value={this.state.environmental_impact_by}
                        exclusive
                        onChange={(e, value) => {
                            if (value !== null) {
                                this.setState({ environmental_impact_by: value });
                            }
                        }}
                        aria-label="file sub category analytics group"
                        color='primary'
                    >
                        <ToggleButton value="energy" aria-label="left aligned" size="small">
                            <Typography variant="body2" fontSize="small">Energy</Typography>
                        </ToggleButton>
                        <ToggleButton value="water" aria-label="centered" size="small">
                            <Typography variant="body2" fontSize="small">Water</Typography>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>

            </>
        )
    }

}
